import { useCallback, useEffect, useState } from 'react';
import {
  editorialCarlaRuizNavy,
  editorialCarlaRuizSuit,
  editorialScorzzoCardigan,
  editorialScorzzoCoat,
  editorialScorzzoDress,
  editorialScorzzoJacket,
} from '@/assets/images';

export default function Editorial() {
  const [active, setActive] = useState<{ src: string; alt: string } | null>(null);

  const open = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    const img = (e.currentTarget as HTMLElement).querySelector('img');
    if (img) setActive({ src: img.src, alt: img.alt });
  }, []);

  useEffect(() => {
    if (!active) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setActive(null);
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [active]);

  return (
    <section id="colecciones" className="py-24 md:py-32 bg-cream-50">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16 md:mb-20">
          <p className="text-[11px] tracking-widest-xl text-ink-500 mb-6">EDITORIAL</p>
          <h2 className="font-display text-5xl md:text-7xl text-ink-900 mb-8">Tu estilo. Tu momento.</h2>
          <p className="text-ink-700 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            Descubre una selección de prendas pensadas para encontrar tu propio estilo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          <div className="md:col-span-7 hover-zoom overflow-hidden bg-white cursor-zoom-in" onClick={open}>
            <img
              src={editorialScorzzoJacket}
              alt="Colección Scorzzo de Sano: chaqueta de rayas anchas y vestido estampado geométrico en blanco y negro con detalles en rojo"
              title="Scorzzo Collection en Sano Llíria"
              className="w-full h-[400px] md:h-[560px] object-contain"
            />
          </div>
          <div className="md:col-span-5 hover-zoom overflow-hidden bg-white cursor-zoom-in" onClick={open}>
            <img
              src={editorialScorzzoDress}
              alt="Modelo con camisa blanca bordada y falda midi roja de la colección Scorzzo"
              title="Scorzzo Collection en Sano Llíria"
              className="w-full h-[400px] md:h-[560px] object-contain"
            />
          </div>
          <div className="md:col-span-3 hover-zoom overflow-hidden bg-white cursor-zoom-in" onClick={open}>
            <img
              src={editorialCarlaRuizSuit}
              alt="Modelo con vestido negro midi de escote redondo y detalle dorado en el cuello de Carla Ruiz"
              title="Carla Ruiz en Sano Llíria"
              className="w-full h-[380px] md:h-[480px] object-contain"
            />
          </div>
          <div className="md:col-span-3 hover-zoom overflow-hidden bg-white cursor-zoom-in" onClick={open}>
            <img
              src={editorialScorzzoCoat}
              alt="Chaqueta de borrego con rayas anchas en negro y crema y bolsillos acolchados de Scorzzo Collection"
              title="Chaqueta Scorzzo en Sano Llíria"
              className="w-full h-[380px] md:h-[480px] object-contain"
            />
          </div>
          <div className="md:col-span-3 hover-zoom overflow-hidden bg-white cursor-zoom-in" onClick={open}>
            <img
              src={editorialCarlaRuizNavy}
              alt="Modelo con traje sastre azul marino de chaqueta cruzada y lazada de Carla Ruiz junto a una piscina"
              title="Carla Ruiz en Sano Llíria"
              className="w-full h-[380px] md:h-[480px] object-contain"
            />
          </div>
          <div className="md:col-span-3 hover-zoom overflow-hidden bg-white cursor-zoom-in" onClick={open}>
            <img
              src={editorialScorzzoCardigan}
              alt="Cárdigan de punto de la colección Scorzzo en Sano Llíria"
              title="Cárdigan Scorzzo en Sano Llíria"
              className="w-full h-[380px] md:h-[480px] object-contain"
            />
          </div>
        </div>
      </div>

      {active && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label={active.alt}
          className="fixed inset-0 z-[100] flex items-center justify-center bg-ink-900/90 p-4 md:p-10 cursor-zoom-out"
          onClick={() => setActive(null)}
        >
          <button
            type="button"
            aria-label="Cerrar"
            className="absolute top-4 right-4 md:top-6 md:right-6 text-white text-3xl leading-none"
            onClick={() => setActive(null)}
          >
            <i className="ri-close-line"></i>
          </button>
          <img src={active.src} alt={active.alt} className="max-w-full max-h-full object-contain" />
        </div>
      )}
    </section>
  );
}